var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-4"},[_c('breadcrumb',{attrs:{"items":_vm.breadcrumbs}}),_c('GenerateReports',{attrs:{"blendId":_vm.blendId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }